import VideoPlayIcon from "./VideoPlayIcon";

export default VideoPlayIcon;
